(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("popper.js"));
	else if(typeof define === 'function' && define.amd)
		define(["popper.js"], factory);
	else if(typeof exports === 'object')
		exports["vue-tooltip"] = factory(require("popper.js"));
	else
		root["vue-tooltip"] = factory(root["popper.js"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('popper.js'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.popper);
        global.index = mod.exports;
    }
})(this, function (exports, _popper) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _popper2 = _interopRequireDefault(_popper);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var tooltipDirective = {
        inserted: function inserted(el, binding) {
            initTooltip(el, binding);
        },
        update: function update(el, binding) {
            var div = el.parentNode.querySelector('.tooltip');
            if (!div) {
                return;
            }

            div.parentNode.removeChild(div);

            initTooltip(el, binding);
        }
    };

    function getPlacement(modifiers) {
        var placement = 'auto';

        if (modifiers.top) {
            placement = 'top';
        }

        if (modifiers.bottom) {
            placement = 'bottom';
        }

        if (modifiers.left) {
            placement = 'left';
        }

        if (modifiers.right) {
            placement = 'right';
        }

        if (modifiers.start) {
            placement += '-start';
        }

        if (modifiers.end) {
            placement += '-end';
        }

        return placement;
    }

    function initTooltip(el, binding) {
        if (binding.value === null) {
            return;
        }

        var placement = getPlacement(binding.modifiers);

        var div = document.createElement('div');
        div.innerText = binding.value;
        div.className = 'hidden tooltip';

        var arrow = document.createElement('div');
        arrow.className = 'tooltip-arrow';

        div.appendChild(arrow);

        var tooltip = el.parentNode.insertBefore(div, el);

        el.addEventListener('mouseover', function () {
            div.classList.remove('hidden');
            Vue.nextTick(function () {
                new _popper2.default(el, tooltip, {
                    placement: placement
                });
            });
        });

        el.addEventListener('mouseout', function () {
            div.classList.add('hidden');
        });
    }

    exports.default = tooltipDirective;
});

/***/ })
/******/ ]);
});